"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLoginClick = exports.getResellerText = exports.GetSalutation = exports.isEud = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const helpers_1 = require("../../../../utils/helpers");
const services_1 = require("../../../../services");
exports.isEud = helpers_1.envConfig.currentBrand === 'EUD';
const genericResellerName = exports.isEud ? 'Representante' : 'Revendedor';
const GetSalutation = ({ reseller }) => ((0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ justify: "space-between", css: { marginBottom: '$5' } }, { children: [(0, jsx_runtime_1.jsx)(flora_react_icons_1.PersonIcon, { size: 32, css: {
                marginRight: '$4',
                background: '$backgroundSecondary',
                borderRadius: '$pill',
                width: '$15',
                height: '$15',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
            } }), (0, jsx_runtime_1.jsxs)(flora_react_1.Text, Object.assign({ size: "bodyLargeStandardRegular", weight: "regular", as: "p" }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ weight: "regular", css: { fontSize: '$2xl' } }, { children: "Ol\u00E1, cliente!" })), (0, jsx_runtime_1.jsx)("br", {}), "Boas-vindas \u00E0 Minha Loja Digital", reseller ? ' de ' + (0, helpers_1.capitalizeName)(reseller.name) : '', "!"] }))] })));
exports.GetSalutation = GetSalutation;
const getResellerText = (reseller) => `É ${!reseller ? genericResellerName : (0, helpers_1.capitalizeName)(reseller.name)} e precisa gerenciar suas vendas?`;
exports.getResellerText = getResellerText;
const trackLoginClick = () => {
    services_1.GoogleAnalyticsService.event({
        event: 'analytics-event',
        event_parameters: {
            event_name: 'click_login_register',
        },
    });
};
exports.trackLoginClick = trackLoginClick;
